// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import CloseCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/CloseCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleOutlinedSvg
  }));
};

CloseCircleOutlined.displayName = 'CloseCircleOutlined';
export default React.forwardRef(CloseCircleOutlined);